import { useState } from "react";
import {
  createFranchiseInquiry,
  CreateFranchiseInquiryRequest,
} from "../api/franchise-inquiry-api";

export const useFranchiseInquiry = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (data: CreateFranchiseInquiryRequest) => {
    try {
      setIsLoading(true);
      setError(null);

      console.log("Submitting franchise inquiry:", data);
      const response = await createFranchiseInquiry(data);

      if (!response.success) {
        throw new Error(response.message || "문의 제출에 실패했습니다.");
      }

      return response;
    } catch (err) {
      const errorMessage =
        err instanceof Error
          ? err.message
          : "문의 제출 중 오류가 발생했습니다.";
      console.error("Franchise inquiry error:", err);
      setError(errorMessage);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    submit,
    isLoading,
    error,
  };
};
